import Vue from 'vue'
import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'

const opts = { treeShake: true }
Vue.use(Vuetify)
export default new Vuetify(opts)
